import React, {Component} from 'react'
let i18n = require("i18next");
let styles = require('../css_modules/tooltips.less');
import classNames from 'classnames';

export default class Tooltips extends Component {
    render() {
        return (
            <div id="tooltips" className={classNames(styles.tooltips)}>
                <image src={require("../images/closetips.png")} className={classNames(styles.closetips)}/>
                <image src={require("../images/tipbear.png")} className={classNames('tipbear')}/>
                <div className={classNames(styles.tipbody,'hidden')}>
                    <span className={classNames(styles.title)}></span>
                    <span className={classNames(styles.content)}></span>
                    <span className={classNames(styles.tips)}></span>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/Tooltips.react.js